import api from "../security/api";

const viewConstantsFindAll = (client, instance) => {
    return api
        .get(`constants/findAll?client=${client}&instance=${instance}`);
};

const constantService = {
    viewConstantsFindAll
};


export default constantService;